
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedHigh as ObiSpeedHighElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-high.js';
 
 
 

 
 export const ObiSpeedHigh = createComponent({
   react: React,
   tagName: 'obi-speed-high',
   elementClass: ObiSpeedHighElement,
   events: {
     
   }
  });
 
 